import React from "react";
import {
  Users, Flower2, Mountain, GraduationCap, Sprout, HeartPulse, Moon, Sun, Layers,
  Store, Briefcase, DollarSign, Cpu, Server, Handshake, Palette, Heart, Newspaper, Circle,
} from "lucide-react";
import { REALM_GROUPS } from "./api";

// One signature hue per parent group (realms inherit their group's color in filters).
export const GROUP_COLORS = {
  circles: "#D4A24E",       // warm gold
  spirit_body: "#E0729B",   // soft rose
  systems: "#14A89A",       // teal
  culture_life: "#A855F7",  // violet
};

// A small glyph for every realm, for faster scanning.
export const REALM_ICONS = {
  community: Users,
  womens_circle: Flower2,
  mens_circle: Mountain,
  homeschooling: GraduationCap,
  soul_growth: Sprout,
  health: HeartPulse,
  astrology_numerology: Moon,
  enlightenment: Sun,
  tarot: Layers,
  business_directory: Store,
  business: Briefcase,
  financial: DollarSign,
  digital: Cpu,
  infrastructure: Server,
  trade: Handshake,
  art: Palette,
  life: Heart,
  matrix_news: Newspaper,
};

export const groupOfRealm = (key) => {
  const g = REALM_GROUPS.find((x) => x.domains.includes(key));
  return g ? g.key : null;
};

export const colorOfRealm = (key) => GROUP_COLORS[groupOfRealm(key)] || "#A855F7";

export const RealmIcon = ({ realm, ...props }) => {
  const Icon = REALM_ICONS[realm] || Circle;
  return <Icon {...props} />;
};
